import styled from "styled-components";
import {
  mediaMaxWidth,
  mediaMaxHeight,
  mediaMinWidth,
} from "../../utils/mediaQueriesTemplate";

export const Backdrop = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;

  ${mediaMaxHeight.phone`
    align-items: unset;
  `}

  ${mediaMaxWidth.tablet`
    align-items: unset;
  `}
`;

export const ModalWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 650px;
  height: 480px;
  z-index: 5;
  padding: 10px 20px;
  position: relative;
  margin-left: 60px;
  overflow: hidden;

  ${mediaMaxWidth.smallDesktop`
    margin-left: unset;
  `}

  ${mediaMaxWidth.tablet`
    width: calc(100vw - 20px);
    top: 10px;
  `}

  ${mediaMaxWidth.phone`
    padding: 10px 10px;
  `}

  ${mediaMaxHeight.phone`
    top: 10px;
  `}
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #343333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  margin: 7px 0;
  display: flex;
  justify-content: space-between;
`;

export const TitleText = styled.div`
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMinWidth.smallDesktop`
    width: 95%;
  `}
`;

export const CloseButton = styled.div`
  cursor: pointer;

  svg {
    color: #a0a0a0;
    font-size: 1.2em;
    transition: 0.1s ease-in-out;

    &:hover {
      color: #402680;
    }
  }
`;

export const Body = styled.div`
  padding: 10px;
  height: 350px;
  overflow: scroll;
  padding-bottom: 60px;

  .jobTitle {
    display: block;
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: unset;
    margin-right: 20px;
  }

  .location {
    display: block;
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .button-group {
    right: 10px;
  }

  ${mediaMaxWidth.tablet`
    height: 320px;

    .jobTitle,
    .location {
      width: calc(100vw - 120px);
      margin-right: 0;
    }
  `}
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;

  button {
    margin: 5px 10px;
  }
`;
